/* Main file to import general scripts. */
import mobileNav from "./components/main-navigation/main-navigation";
mobileNav(Drupal, once);

import announcementBackground from "./components/announcement-banner/announcement-banner";
announcementBackground(Drupal, once);

import tables from "./components/table/table";
tables(Drupal, once);
